import { getBrand } from './brand'
import { version } from '../../package.json'

export const xUiApp = `${getBrand().replace('.', '')}.auth-intermediate/${version}`
